import { UiUtilities } from '@yiluhub/ui-sdk-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PaymentInputContextProvider } from 'context';

import { PageHeading } from 'components';
import { SummaryLayout } from 'components/Layout';
import { LoadingPageAnimation } from 'components/LoadingPageAnimation';
import { PaymentInformation } from 'components/PaymentInformation';
import ProgressBar from 'components/ProgressBar';

import { EurailProductSummary } from 'modules/eurail/components/EurailProductSummary';

import { useEurailPaymentInputPage } from './hooks';
import './styles.scss';

const PaymentInputPage: React.FC = () => {
  return (
    <div className="eurail-pip">
      <PaymentInputContextProvider>
        <PaymentInputPageInner />
      </PaymentInputContextProvider>
    </div>
  );
};

const PaymentInputPageInner: React.FC = () => {
  const { t } = useTranslation();
  const { isPageReady, paymentInformationFormProps, eurailProductSummaryProps } =
    useEurailPaymentInputPage();

  const isDesktop = UiUtilities.useMediaMatch('--viewport-l');

  if (!isPageReady) {
    return <LoadingPageAnimation />;
  }

  return (
    <div className="form-container-wrapper">
      <div className="form-container container">
        <div className="content">
          <ProgressBar />
          {eurailProductSummaryProps && !isDesktop && (
            <EurailProductSummary {...eurailProductSummaryProps} />
          )}
          <PageHeading text={t('Header - Payment')} />
          {paymentInformationFormProps && <PaymentInformation {...paymentInformationFormProps} />}
        </div>
        {eurailProductSummaryProps && isDesktop && (
          <SummaryLayout>
            <EurailProductSummary {...eurailProductSummaryProps} />
          </SummaryLayout>
        )}
      </div>
    </div>
  );
};

export default PaymentInputPage;
